
import commonPageService from 'mCommon/services/commonPageService';
import { IUserInfo } from 'globalCommon/services/getUserInfo';
import { syncRender } from 'globalCommon/services/syncRender';
import { showCustomImage } from 'globalCommon/utils';
import { UserLogoMap } from 'pcCommon/utils/imageSource';
import './style.css';

const foldChildClass = 'down,up';
const foldClass = 'page-left-right-content-text-item-icon type-fold';
const tabClass = 'page-left-right-content-text-tab-header-item type-tab';
const foldTitleClass = 'page-left-right-content-text-item-title type-fold';
const tabChildClass = 'page-left-right-content-text-tab-header-item-container type-tab';
const foldTitleContainerClass = 'page-left-right-content-text-item-title-container type-fold';

function adaptiveFoldDom(element: any) {
    const result = foldChildClass.split(',').some((className) => {
        return Array.from(element.classList).includes(className);
    });

    if (result) {
        return element.parentElement.parentElement.parentElement.parentElement;
    }

    if (element.className.includes(foldClass)) {
        return element.parentElement.parentElement.parentElement;
    }

    if (element.className.includes(foldTitleClass)) {
        return element.parentElement.parentElement.parentElement;
    }

    if (element.className.includes(foldTitleContainerClass)) {
        return element.parentElement.parentElement;
    }

    return element;
}

function handleFoldIconChange(targetElement: HTMLElement) {
    const targetElementParent = targetElement.parentElement;
    if (Array.from(targetElement.classList).includes('close')) {
        Array.from(targetElementParent?.children || []).forEach((element: any) => {
            element.classList.remove('open', 'slide');
            element.classList.add('close');
        });
        targetElement.classList.add('open', 'slide');
    }
}

function handleClickFold(element: any) {
    const targetElement = adaptiveFoldDom(element);
    handleFoldIconChange(targetElement);
}

function adaptiveTabDom(element: any) {
    if (element.className.includes(tabChildClass)) {
        return element.parentElement;
    }
    return element;
}

function handleTabBodyChange(targetElement: any, targetElementIndex: number) {
    const descContainerDom = targetElement.parentElement.parentElement.parentElement;
    const tabBodyListDom: any = Array.from(descContainerDom.children || []).find((element: any) => {
        return element.className.includes('page-left-right-content-text-tab-body-list type-tab');
    });
    const tabBodyListContainerDom = tabBodyListDom.children[0];
    Array.from(tabBodyListContainerDom.children || []).forEach((element: any) => {
        element.classList.remove('show');
    });
    tabBodyListContainerDom.children[targetElementIndex].classList.add('show');
}

function handleTabChange(targetElement: any) {
    const targetElementIndex = targetElement.dataset.index as number;
    const targetElementParent = targetElement.parentElement;
    if (!targetElement.className.includes('active')) {
        Array.from(targetElementParent.children || []).forEach((element: any) => {
            element.classList.remove('active');
        });
        targetElementParent.children[targetElementIndex].classList.add('active');
        handleTabBodyChange(targetElement, targetElementIndex);
    }
}

function handleClickTab(element: any) {
    const targetElement = adaptiveTabDom(element);
    handleTabChange(targetElement);
}

function handlePageClick(e: any) {
    const { target } = e;

    let targetClassName = target.className;
    const parentClassName = target.parentElement.className;

    if (target.nodeName === 'svg') {
        targetClassName = target.className.baseVal;
    }

    if (parentClassName.includes?.(foldClass) || targetClassName.includes?.(foldClass) || targetClassName.includes?.(foldTitleClass) || targetClassName.includes?.(foldTitleContainerClass)) {
        handleClickFold(target);
    }
    if (parentClassName.includes?.(tabClass) || targetClassName.includes?.(tabClass)) {
        handleClickTab(target);
    }
}

function callback(userInfo: IUserInfo) {
    if (userInfo && userInfo.umu_id) {
        const freeuseList = document.getElementsByClassName('page-home-leading-primary free-use');
        let index = freeuseList.length - 1;
        while (index >= 0) {
            freeuseList[index].remove();
            index--;
        }
    }
}

function init() {
    showCustomImage(UserLogoMap, 'customer-img');
    commonPageService({ cb: callback, renderAfter: syncRender });
    const pageDom = document.querySelector('.page.page-home');
    pageDom?.addEventListener('click', handlePageClick);
}

init();
